/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAvailableFacilitiesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAvailableFacilitiesQuery = { __typename?: 'Query', facilities?: Array<{ __typename?: 'Facility', id: string, name: string, photoRequired: boolean, type: Types.FacilityType, scanTypes?: Array<{ __typename?: 'FacilityScanTypes', id: string, name: string }> | null, productTypes?: Array<{ __typename?: 'FacilityProductTypes', id: string, name: string }> | null } | null> | null };


export const GetAvailableFacilitiesDocument = gql`
    query GetAvailableFacilities {
  facilities(pagination: {orderBy: {name: ASC}}) {
    id
    name
    photoRequired
    scanTypes {
      id
      name
    }
    type
    productTypes {
      id
      name
    }
  }
}
    `;

/**
 * __useGetAvailableFacilitiesQuery__
 *
 * To run a query within a React component, call `useGetAvailableFacilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableFacilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableFacilitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableFacilitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableFacilitiesQuery, GetAvailableFacilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableFacilitiesQuery, GetAvailableFacilitiesQueryVariables>(GetAvailableFacilitiesDocument, options);
      }
export function useGetAvailableFacilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableFacilitiesQuery, GetAvailableFacilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableFacilitiesQuery, GetAvailableFacilitiesQueryVariables>(GetAvailableFacilitiesDocument, options);
        }
export function useGetAvailableFacilitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableFacilitiesQuery, GetAvailableFacilitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableFacilitiesQuery, GetAvailableFacilitiesQueryVariables>(GetAvailableFacilitiesDocument, options);
        }
export type GetAvailableFacilitiesQueryHookResult = ReturnType<typeof useGetAvailableFacilitiesQuery>;
export type GetAvailableFacilitiesLazyQueryHookResult = ReturnType<typeof useGetAvailableFacilitiesLazyQuery>;
export type GetAvailableFacilitiesSuspenseQueryHookResult = ReturnType<typeof useGetAvailableFacilitiesSuspenseQuery>;
export type GetAvailableFacilitiesQueryResult = Apollo.QueryResult<GetAvailableFacilitiesQuery, GetAvailableFacilitiesQueryVariables>;